import { useField } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Switch } from '@@/form-components/SwitchField/Switch';
import { InsightsBox } from '@@/InsightsBox';

const fieldKey = 'Observability';

// ensure to add a disclaimer with the info of not scale tested and only for non-production environments to the tooltip
export function EnableObservabilitySwitch() {
  const [inputProps, meta, helpers] = useField<boolean>(fieldKey);

  return (
    <>
      <InsightsBox
        header="Disclaimer"
        type="slim"
        content={
          <div className="space-y-3">
            <div>
              <p className="font-semibold mb-2">
                ⚠ Experimental Feature Notice
              </p>
              <p className="mb-2">
                This feature enables alerting capabilities as part of our
                evolving Observability module which is currently in an
                experimental phase and has not been tested for performance,
                reliability, or scalability. As such:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>
                  It may exhibit unstable behavior or incomplete data under load
                </li>
                <li>
                  Alert thresholds, data retention, and integration logic are
                  subject to change without notice
                </li>
                <li>
                  Telemetry accuracy, especially across distributed
                  environments, may be limited
                </li>
              </ul>
            </div>

            <p>
              We strongly recommend using this feature in{' '}
              <span className="font-semibold">
                non-production or test environments only
              </span>{' '}
              until full support and documentation are available in a future
              release.
            </p>

            <p>
              For known limitations, implementation notes, or contributing
              feedback,{' '}
              <a
                href="https://github.com/portainer/portainer/issues"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-700 underline"
              >
                please open an issue or share your experience
              </a>
              .
            </p>
          </div>
        }
        className="mb-3"
      />
      <FormControl
        inputId="experimental_observability"
        label="Enable Observability"
        size="medium"
        errors={meta.error}
      >
        <Switch
          id="experimental_observability"
          data-cy="enable-observability-switch"
          name={fieldKey}
          className="space-right"
          checked={inputProps.value}
          onChange={handleChange}
        />
      </FormControl>
    </>
  );

  function handleChange(enable: boolean) {
    helpers.setValue(enable);
  }
}
